// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__9INg9","inputWrap":"CustomTip_inputWrap__hY0lj"};